import {FormControl, MenuItem, Select, SelectChangeEvent} from '@mui/material';
import React from 'react';
import {SelectOptions} from "../../constants/AppConstants";
import {makeStyles} from "@mui/styles";

const useStyles = makeStyles(() => ({
    root: {
        color: "#000 !important" as any,
        background: "#F2F2F2",
        borderRadius: "8px !important" as any,
        "& .MuiOutlinedInput-notchedOutline": {
            border: "none !important" as any
        },
        "& .MuiSelect-select": {
          padding: "12px 32px 12px 12px !important" as any
        }
    },
    required: {
        color: "#EA6B44"
    },
    label: {
        marginBottom: 4
    }
}));

interface Props {
    readonly options: SelectOptions[],
    readonly label?: string
    readonly onValueChange: (value: string) => void
    readonly required?: boolean
    readonly [key: string]: any
}

export function AppSelect({options,required,label,onValueChange, ...props}:Props) {
    const classes = useStyles();
    const [value, setValue] = React.useState(props.defaultValue ?? "");

    const handleChange = (event: SelectChangeEvent) => {
        setValue(event.target.value as string);
        onValueChange(event.target.value as string)
    };
    return (
        <FormControl fullWidth={props?.fullWidth} >
            {label && <p className={classes.label} id="demo-simple-select-label">{label} {required && <span className={classes.required}>(required)</span>}</p>}
            <Select
                className={classes.root}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={value}
                {...props}
                defaultValue="p"
                onChange={handleChange}
            >
                {
                    options.length > 0 ? options.map(item => {
                        return (
                            <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
                        )
                    }) : (
                        <MenuItem value="" disabled>Empty List</MenuItem>
                    )
                }
            </Select>
        </FormControl>
    );
}

